import { logForcedTokenRefresh } from '../lib/authDiagnostics';
import { shouldSuppressAutomaticRefresh } from '../lib/authTerminalLatch';

export type ForcedRefreshLog = { kind: '401' | 'upload_401'; url: string };

export function logForcedRefreshFromSingleFlight(forcedLog: ForcedRefreshLog, deduped: boolean): void {
  if (shouldSuppressAutomaticRefresh()) return;
  const reason =
    forcedLog.kind === 'upload_401'
      ? (deduped ? 'upload_401_deduped_inflight' : 'upload_401_initiate_refresh')
      : (deduped ? '401_deduped_inflight' : '401_initiate_refresh');
  logForcedTokenRefresh(reason, forcedLog.url);
}
